type OfficeButtonProps = {
  officeLocation: string
  isSelected: boolean
  onClick: (event: any) => void
}

export const OfficeButton = ({
  officeLocation,
  isSelected,
  onClick,
}: OfficeButtonProps) => {
  return (
    <div className="dropdown-item">
      <button
        onClick={onClick}
        role="menuitem"
        aria-selected={isSelected}
        data-location={officeLocation}
        aria-label={`open roles in ${officeLocation}`}
      >
        {officeLocation}
      </button>
    </div>
  )
}
